import React from 'react';
import { string } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { useProduct } from '~/@thd-nucleus/data-sources';
import * as analytics from './analytics/PromotionsAnalytics';
import './promotion.style.scss';

const Promotion = ({ channel, itemId, storeId }) => {

  const { data, loading, error } = useProduct({ itemId, storeId, domains: ['pricing'] });

  if (loading) return null;

  if (error && !data) {
    return <pre><code>{error.toString()}</code></pre>;
  }

  if (!data) return null;

  const { description, dates } = data?.model?.product?.pricing?.promotion || {};

  const { shortDesc, longDesc } = description || {};

  if (!shortDesc) return null;

  const { end, start } = dates || {};

  return (
    <div className="promotion">
      <Tooltip
        channel={channel}
        content={(
          <div>
            <b>Promotion Details</b>
            <div className="promotion__tooltip">{`Price Valid: ${start} - ${end}`}</div>
            {longDesc && <div>{longDesc}</div>}
            {!longDesc && <div>{shortDesc}</div>}
          </div>
        )}
        closeButton
      >
        <button
          type="button"
          className="promotion__link"
          href="#"
          onClick={analytics.promoClickEvent}
        >
          {shortDesc}
        </button>
      </Tooltip>
    </div>
  );
};
Promotion.propTypes = {
  channel: string.isRequired,
  storeId: string.isRequired,
  itemId: string.isRequired
};

export default Promotion;
